import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper";

export const getCountryList = () => get(url.COUNTRY_DEFINITIONS);
export const addCountry = record => post(url.COUNTRY_INSERT, record);
export const updateCountry = record => put(url.COUNTRY_UPDATE, record);
export const deleteCountry = guid => del(url.COUNTRY_DELETE, { params: { guid } });